module.exports = __webpack_public_path__ + "img/11.7c2fb760.jpg";